module.exports = __webpack_public_path__ + "static/media/et_7.27b93c49.png";